
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AboutHero from "@/components/sections/about/AboutHero";
import AboutVision from "@/components/sections/about/AboutVision";
import DifferenceSection from "@/components/sections/about/DifferenceSection";
import TeamSection from "@/components/sections/about/TeamSection";
import WhySection from "@/components/sections/about/WhySection";
import FutureSection from "@/components/sections/about/FutureSection";
import JoinSection from "@/components/sections/about/JoinSection";
import ChatOption from "@/components/ChatOption";
import { useIsMobile } from "@/hooks/use-mobile";

const AboutUs = () => {
  const isMobile = useIsMobile();
  return (
    <div className="min-h-screen bg-gradient-to-b from-corporate-primary-25 to-white">
      <Header />
      <AboutHero />
      <AboutVision />
      <DifferenceSection />
      <TeamSection />
      <WhySection />
      <FutureSection />
      <JoinSection />
      <Footer />
      {/* Only show ChatOption on desktop */}
      {!isMobile && (
        <ChatOption />
      )}
    </div>
  );
};

export default AboutUs;
